import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import api from "../api/axios";

import "swiper/css";
import "swiper/css/pagination";
import "../styles/style.css";

const TestimonialsSection = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await api.get("companyblog/testimonials/");
        setTestimonials(res.data.data);
      } catch (error) {
        console.error("Failed to load testimonials", error);
      }
    };

    fetchTestimonials();
  }, []);

  if (!testimonials.length) return null;

  return (
    <div className="container-xxl py-5 testimonial-section">
      <div className="container py-5">
        <div className="row g-5 align-items-center">

          {/* LEFT */}
          <div className="col-lg-5">
            <span className="badge rounded-pill border text-primary px-3 mb-3">
              Testimonial
            </span>
            <h1 className="fw-bold mb-4">What Our Clients SAYS!</h1>
            <p className="mb-4 text-muted">
              Real feedback from clients who have experienced our quality service and trusted solutions.
            </p>
          </div>

          {/* RIGHT */}
          <div className="col-lg-7 position-relative">
            <div className="testimonial-divider"></div>

            {/* Custom arrows */}
            <div className="testimonial-nav">
              <button className="testimonial-prev">
                <i className="fa fa-angle-left"></i>
              </button>
              <button className="testimonial-next">
                <i className="fa fa-angle-right"></i>
              </button>
            </div>

            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              slidesPerView={1}
              loop
              autoplay={{ delay: 5000 }}
              pagination={{
                el: ".testimonial-pagination",
                clickable: true,
              }}
              navigation={{
                prevEl: ".testimonial-prev",
                nextEl: ".testimonial-next",
              }}
              speed={700}
            >
              {testimonials.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="testimonial-content">
                    <i className="fa fa-quote-left quote-icon"></i>

                    <p className="testimonial-text">
                      {item.feedback}
                    </p>

                    <div className="d-flex align-items-center mt-4">
                      <img
                        src={item.image_url}
                        alt={item.person_name}
                        className="rounded-circle"
                        width="100px"
                        height="100px"
                        loading="lazy"
                      />
                      <div className="ps-3">
                        <h6 className="mb-0 fw-bold">
                          {item.person_name}
                        </h6>
                        <small className="text-muted">
                          {item.person_occupation}
                        </small>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="testimonial-pagination mt-4"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsSection;
